import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";

const formatDriveImage = (url) => {
  if (!url) return null;

  if (url.includes("drive.google.com")) {
    const match = url.match(/\/d\/([^/]+)/);
    if (match?.[1]) {
      return `https://drive.google.com/thumbnail?id=${match[1]}&sz=w1200`;
    }
  }

  return url;
};

const BlogDetail = () => {
  window.scrollTo(0, 0);
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetch("https://sattva-backend.demetrix.in/blogs")
      .then(res => res.json())
      .then(data => {
        if (data.status === "success") {
          const found = data.data.find(
            item =>
              item.slug === slug &&
              item.is_published &&
              !item.is_deleted &&
              !item.deleted_at
          );
          setBlog(found || null);
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-slate-950">
        <div className="flex flex-col items-center gap-4">
          {/* Spinner */}
          <div className="w-12 h-12 border-4 border-gray-300 dark:border-slate-700 
                        border-t-gray-900 dark:border-t-white 
                        rounded-full animate-spin">
          </div>

          {/* Optional text */}
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Loading Blogs...
          </p>
        </div>
      </div>
    );
  }

  if (!blog) return <p className="pt-20 text-center">Blog not found</p>;

  // IMAGE
  const imageMedia = blog.media?.find(m => m.type === "image");
  const imageUrl = formatDriveImage(imageMedia?.url);

  // VIDEO
  const videoMedia = blog.media?.find(m => m.type === "video");
  let videoUrl = null;
  if (videoMedia?.url?.includes("youtube.com")) {
    const id = videoMedia.url.match(/v=([^&]+)/)?.[1];
    if (id) videoUrl = `https://www.youtube.com/embed/${id}`;
  }

  return (
    <div className="min-h-screen pt-20 pb-20 max-w-4xl mx-auto px-6">

      <div className="flex flex-col md:flex-row items-center justify-between mb-4 pt-16 md:gap-4">
        <h1 className="text-3xl font-bold mb-4 flex-1">
          {blog.title}
        </h1>
        <div className="">
          <button
            onClick={() => navigate(-1)}
            className="px-4 py-2 text-sm font-medium text-primary border border-primary rounded-lg hover:bg-primary/10 transition-colors dark:text-primary dark:hover:bg-primary/20"
          >
            Close
          </button>
        </div>
      </div>

      {/* Title */}


      {/* Author */}
      <p className="text-sm text-gray-500 mb-6">
        Authored by: <span className="font-medium text-gray-700">{blog.author}</span>
      </p>
      <p className="text-gray-500 italic mb-6">
        {blog.summary}
      </p>

      {/* Text + Image */}
      <div className="grid md:grid-cols-3 gap-6 mb-10 items-start">

        {/* Text */}
        <div className="md:col-span-2 text-gray-700 whitespace-pre-line leading-relaxed">
          {blog.content}
        </div>

        {/* Image */}
        {imageUrl && (
          <div className="md:col-span-1">
            <img
              src={imageUrl}
              alt={blog.title}
              className="w-full rounded-lg"
              loading="lazy"
              referrerPolicy="no-referrer"
              onError={(e) => {
                e.currentTarget.src = "/placeholder.jpg"; // optional fallback
              }}
            />
          </div>
        )}

      </div>

      {/* Video */}
      {videoUrl && (
        <div className="mt-10">
          <iframe
            src={videoUrl}
            className="w-full h-[400px] rounded-lg"
            allowFullScreen
            title="Blog Video"
          />
        </div>
      )}


    </div>
  );

};

export default BlogDetail;
